import React from "react";
import PropTypes from "prop-types";
import Button from "../Button";
import CtaLink from "../CtaLink";
import { segmentTrackEvent } from "@website-builder/utilities-index";

const AElement = (props) => React.createElement("a", props);

const CtaButton = (props) => {
	const { cta, Link, pathName, className } = props;

	if (!cta) {
		return <></>;
	}

	const { link: linkProps, type, text, color, darkBg } = cta;

	const triggerSegmentEvent = () => {
		const segmentEventData = props.segmentEventData;
		if (segmentEventData) {
			const { eventName, eventProperties } = segmentEventData;
			segmentTrackEvent(eventName, eventProperties);
		}
	};

	const ButtonElement = () => {
		return (
			<Button
				color={color}
				type={type}
				darkBg={darkBg}
				className={className}
				onClick={triggerSegmentEvent}
			>
				{text}
			</Button>
		);
	};

	return (
		<CtaLink {...linkProps} Link={Link} pathName={pathName}>
			{ButtonElement()}
		</CtaLink>
	);
};

const LinkType = PropTypes.shape({
	type: PropTypes.oneOf(["hash", "external", "internal", "typeform"]),
	value: PropTypes.string,
});

CtaButton.propTypes = {
	cta: PropTypes.shape({
		type: PropTypes.oneOf(["solid", "outline"]).isRequired,
		text: PropTypes.string.isRequired,
		color: PropTypes.string,
		link: LinkType,
	}),
	className: PropTypes.string,
	pathName: PropTypes.string,
	Link: PropTypes.func.isRequired,
	segmentEventData: PropTypes.object,
};

CtaButton.defaultProps = {
	cta: null,
	className: "",
	pathName: "",
	Link: AElement,
	segmentEventData: null,
};

export default CtaButton;
